import styled, { css } from 'styled-components';
import { DialogTitle, Icon, IconButton } from '@material-ui/core';

interface StyledDialogTitleProps {
  $hasIcon: boolean;
}

export const StyledDialogTitle = styled(DialogTitle)<StyledDialogTitleProps>`
  padding-right: 56px;

  ${(props) =>
    props.$hasIcon &&
    css`
      padding-left: 52px;
    `}
`;

export const StyledIcon = styled(Icon)`
  position: absolute;
  left: 20px;
  top: 19px;
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  right: 8px;
  top: 8px;
`;
